import { Box, SxProps, Theme } from '@mui/material';
import { isCapacitorNative } from 'Utils/Constants';

interface TouchBoxProps {
  sx?: SxProps<Theme>;
  onClick?: () => void;
  children?: React.ReactNode;
  [key: string]: unknown;
}

const TouchBox = ({ sx = {}, onClick, children, ...rest }: TouchBoxProps) => {
  const isCapacitor = isCapacitorNative();

  return (
    <Box
      sx={{
        ...sx,
        ...(isCapacitor
          ? {
              touchAction: 'manipulation',
              WebkitTapHighlightColor: 'transparent',
              cursor: 'pointer',
            }
          : { cursor: 'pointer' }),
      }}
      onTouchStart={isCapacitor ? onClick : undefined}
      onClick={!isCapacitor ? onClick : undefined}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default TouchBox;
